'use client';

import type { ExecutiveTeamMemberType } from './data';

import { Box, Container, Image, SimpleGrid, Text, VStack } from '@/components';

const ExecutiveTeamMember: ExecutiveTeamMemberType = ({ executiveTeam }) => {
  const sortedData = executiveTeam?.sort((a, b) => a.priority - b.priority);

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Container pt={{ base: '60px', md: '94px' }}>
        <SimpleGrid
          columns={{ base: 2, md: 3, lg: 4, xl: 5 }}
          gap={{ base: '13px', md: '26px' }}
          justifyContent="center"
          alignItems="center"
          maxW="1000px"
          margin="0 auto"
        >
          {sortedData?.map((item, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              position="relative"
              zIndex={0}
            >
              <Box
                role="group"
                position="relative"
                width="full"
                aspectRatio={162 / 212}
                borderRadius="xs"
                sx={{ img: { objectFit: 'cover' } }}
              >
                <Image
                  src={item?.current_image}
                  alt={item?.current_alt_image}
                  fill
                />
              </Box>
              <VStack
                alignItems="flex-start"
                justifyContent="space-between"
                width="100%"
                bottom={2.5}
                right={2.5}
                pb={1.5}
                pt="16px"
                gap={0.5}
                zIndex="docked"
              >
                <Text
                  color="text"
                  fontWeight={700}
                  fontSize={{ base: 'xs', md: 'md' }}
                  zIndex="docked"
                >
                  {item.first_name} {item.last_name}
                </Text>
                <Text
                  fontWeight={400}
                  fontSize={{ base: '2xs', md: 'sm' }}
                  color="gray.700"
                  zIndex="docked"
                >
                  {item.job_position}
                </Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};
export default ExecutiveTeamMember;
